export const ACTION_CODE = 'CUSTOMER' + '_ACTION';
